
import {debounceTime, take} from 'rxjs/operators';
import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {StateDataId, BrowserSessionStateId} from "../../types/ids";
import {BrowserSessionService} from "../../services/browsersession.service";
import $ from "jquery";
import 'jstree';
import {StateInfoItem} from "../../components/state/stateinfoitemrendererfactory";
import {HighlightedElement} from "../../components/state/highlightedElement.stateinfo";
import {Subject} from "rxjs";
import {StateDataInfo} from '../../types/browsersession';
import {WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../modaltoolcontainer/modaltoolcontainer.component';

export class StatedataViewerToolConfig implements WebmateToolConfig {
    toolName = "Statedata";

    constructor(public readonly stateDataId: StateDataId, public readonly stateId: BrowserSessionStateId) {
    }
}

/**
 * Shows StateData contained in a State.
 */
@Component({
    selector: "wm-statedataviewer",
    templateUrl: "./statedataviewer.component.html",
    styleUrls: ['./statedataviewer.component.less'],
})
export class StatedataViewerComponent implements OnDestroy {

    @ViewChild("treeroot") elementTreeRoot: ElementRef;

    private _stateDataId: StateDataId;
    stateId: StateDataId;

    private rectTree = {};

    domStructure: any;
    elementTreeData: any;
    stateDataEmpty = false;

    stateDataInfo: StateDataInfo;

    rectangles: StateInfoItem[] = [];

    activeNode: any;
    nodesToRectangles = new Map<string /*node id */, any /* Rectangle */>();

    searchInput = new Subject<string>();

    setSearchInput(input: string) {
        this.searchInput.next(input);
    }

    activeNodeAttributeKeys() {
        return Object.keys(this.activeNode['attributes']);
    }

    constructor(@Inject(TOOL_CONTAINER_DATA) private data: StatedataViewerToolConfig, private browserSessionService: BrowserSessionService) {
        if (data) {
            this._stateDataId = data.stateDataId;
            this.stateId = data.stateId;
        }
    }

    ngOnInit() {
        this.browserSessionService.getStateDataInfo$(this._stateDataId).pipe(take(1)).subscribe(info => {
            this.stateDataInfo = info;
        });

        this.browserSessionService.getStateDataDomStructure$(this._stateDataId).pipe(take(1)).subscribe(domStructure => {
            this.domStructure = domStructure;
            if (!!domStructure) {
                this.elementTreeData = this.makeElementTreeFromDomStructure(this.domStructure);
                // Wait one CD step until the elementTreeRoot is available in the DOM
                setTimeout(() => {
                    let treeRoot = this.elementTreeRoot.nativeElement;
                    let jstreeConf = {
                        core: {
                            data: [this.elementTreeData],
                            themes: {
                                icons: false
                            },
                            animation: false
                        },
                        plugins: ['wholerow', 'search']
                    };
                    $(treeRoot)
                        .jstree(jstreeConf)
                        .on('hover_node.jstree', (ev: any, data: any) => {
                            let nodeData = data['node']['data'];
                            if (nodeData.rectangle) {
                                this.highlightNode(nodeData);
                            }
                        })
                        .on('activate_node.jstree', (ev: any, data: any) => {
                            this.activateNode(data['node']['data']['nodeId']);
                        });
                }, 0)
            } else {
                this.stateDataEmpty = true;
            }
        });
        this.searchInput.asObservable().pipe(debounceTime(250)).subscribe(searchInput => {
            $(this.elementTreeRoot.nativeElement).jstree(true).search(searchInput);
        });
    }

    highlightNode(nodeData: any) {
        this.rectangles = [new HighlightedElement({
            x: nodeData.rectangle['x'],
            y: nodeData.rectangle['y'],
            width: nodeData.rectangle['width'],
            height: nodeData.rectangle['height']
        })];
    }

    activateNode(nodeId: string) {
        this.browserSessionService.getStateDataDomNode$(this._stateDataId, nodeId).subscribe(nodeInfo => {
            if (typeof(nodeInfo) !== "object") {
                return;
            }

            this.activeNode = nodeInfo;
        });
    }

    // TODO: make highlighting possible using mouseover (and activation using click). Use 2d segment tree or something
    // onMouseMove(x: number, y: number) {
    //     this.nodesToRectangles.forEach((rectangle, nodeId) => {
    //         if (rectangle.x < x && rectangle.x + rectangle.width > x && rectangle.y < y && rectangle.y + rectangle.height > y) {
    //             this.highlightNode({rectangle: rectangle});
    //         }
    //     });
    // }

    // todo: make tail recursive (maybe, if this hurts)
    makeElementTreeFromDomStructure(node: any): any {
        let result = {
            text: '&lt;' + node.nodeName + ' ' + Object.entries(node['attributes'] || {}).map(([key, value]) => `${key}="${value}"`).join(' ') + '&gt;',
            data: node,
            children: undefined
        };
        this.nodesToRectangles.set(node['nodeId'], node['rectangle']);

        let children = (node['children'] || [])
            .filter((elem: any) => elem['nodeName'] !== 'wmtext')
            .map((elem: any) => this.makeElementTreeFromDomStructure(elem));

        result.children = children;
        return result;
    }

    ngOnDestroy() {
        try {
            $(this.elementTreeRoot.nativeElement).jstree(true).destroy(false);
        } catch(error) {
            console.debug(error);
        }

        this.nodesToRectangles.clear();
    }
}
